// A one-line way into the PV sizing analysis from the places where the size
// is decided (the PV tab's capacity field, the financial assumptions). Renders
// nothing unless the project is a behind-the-meter PV project.
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link, Typography } from "@mui/material";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { useLanguage } from "../../context/LanguageContext";
import { FEASIBILITY_ANALYSES, projectSupportsPvSizing } from "../../navigation/sections";

const TO = FEASIBILITY_ANALYSES.find((a) => a.key === "pvSizing")?.to || "/feasibility/pv-sizing";

export default function PvSizingEntryLink({ cfg, variant = "capacity", sx }) {
  const { isGreek } = useLanguage();
  if (!projectSupportsPvSizing(cfg)) return null;
  const label = variant === "capacity"
    ? (isGreek ? "Προτεινόμενη ισχύς από οικονομική διαστασιολόγηση →" : "Suggested size from the economic sizing →")
    : (isGreek ? "Οικονομική διαστασιολόγηση ΦΒ αυτοκατανάλωσης →" : "Economic sizing of the self-consumption PV →");
  return (
    <Typography variant="caption" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, ...sx }} data-testid="pv-sizing-entry">
      <TuneOutlinedIcon sx={{ fontSize: 14, opacity: 0.7 }} />
      <Link component={RouterLink} to={TO} underline="hover">{label}</Link>
    </Typography>
  );
}
